import React from 'react';
import { Briefcase, MapPin, Clock, ArrowRight, Laptop, Heart, GraduationCap, Coffee } from 'lucide-react';
import Button from '../components/Button';  

const Jobs = () => {
  const jobs = [
    { title: "Senior Full Stack Engineer", department: "Engineering", location: "Remote, US", type: "Full-Time" },
    { title: "Product Designer (UI/UX)", department: "Design", location: "New York, NY", type: "Full-Time" },
    { title: "Cloud Architect (AWS)", department: "DevOps", location: "Remote, Global", type: "Full-Time" },
    { title: "Technical Project Manager", department: "Management", location: "London, UK", type: "Contract" }
  ];

  const perks = [
    { icon: Laptop, title: "Top-Tier Gear", desc: "Latest MacBook Pro, 4K monitors, and an ergonomic home office stipend from day one." },
    { icon: Heart, title: "Health & Wellness", desc: "Comprehensive health, dental, and vision insurance for you and your dependents." },
    { icon: GraduationCap, title: "Learning Budget", desc: "$2,000 annual budget for courses, conferences, and books to accelerate your growth." },
    { icon: Coffee, title: "Flexible Working", desc: "Work when and where you are most productive. We care about output, not hours online." }
  ];

  return (
    <div className="pt-24 min-h-screen bg-navy/5">
      {/* Hero */}
      <section className="py-20 text-center">
        <div className="container-custom">
          <div className="inline-block mb-4 px-4 py-1.5 rounded-full bg-primary/10 border border-primary/20">
            <span className="text-primary font-semibold text-sm tracking-wide uppercase">Careers</span>
          </div>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-navy mb-6">
            Do the Best Work of <br className="hidden md:block" />
            <span className="text-primary">Your Life</span>
          </h1>
          <p className="text-lg md:text-xl text-navy/70 max-w-3xl mx-auto leading-relaxed mb-10">
            We're building a culture of high agency, radical candor, and technical excellence. 
            Join us in solving some of the hardest engineering challenges for fast-growing companies.
          </p>
          <a href="#open-positions">
            <Button variant="primary" className="px-8 py-4 text-lg">
              View Open Roles
            </Button>
          </a>
        </div>
      </section>

      {/* Perks Section */}
      <section className="py-20 bg-white">
        <div className="container-custom">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-navy mb-4">Why Join KEEL?</h2>
            <p className="text-navy/60 max-w-2xl mx-auto text-lg">We invest heavily in our team. When you perform at your best, everyone wins.</p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {perks.map((perk, i) => (
              <div key={i} className="p-8 rounded-2xl bg-navy/5 border border-transparent hover:border-navy/10 transition-colors">
                <div className="w-12 h-12 bg-white rounded-xl shadow-sm flex items-center justify-center text-primary mb-6">
                  <perk.icon size={24} />
                </div>
                <h3 className="text-xl font-bold text-navy mb-3">{perk.title}</h3>
                <p className="text-navy/70 leading-relaxed">{perk.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Open Positions List */}
      <section id="open-positions" className="py-24 bg-navy/5">
        <div className="container-custom max-w-4xl">
          <div className="flex items-center justify-between mb-10">
            <h2 className="text-3xl font-bold text-navy">Open Positions</h2>
            <span className="bg-primary/10 text-primary font-bold px-4 py-1.5 rounded-full text-sm">
              {jobs.length} Jobs
            </span>
          </div>

          <div className="space-y-4">
            {jobs.map((job, index) => (
              <div key={index} className="bg-white p-6 md:p-8 rounded-2xl shadow-sm border border-navy/5 hover:shadow-xl hover:shadow-navy/5 transition-all group flex flex-col md:flex-row md:items-center justify-between gap-6 cursor-pointer">
                <div>
                  <h3 className="text-2xl font-bold text-navy mb-3 group-hover:text-primary transition-colors">{job.title}</h3>
                  <div className="flex flex-wrap items-center gap-4 text-sm font-medium text-navy/60">
                    <span className="flex items-center gap-1.5"><Briefcase size={16} /> {job.department}</span>
                    <span className="hidden md:inline w-1 h-1 bg-navy/20 rounded-full"></span>
                    <span className="flex items-center gap-1.5"><MapPin size={16} /> {job.location}</span>
                    <span className="hidden md:inline w-1 h-1 bg-navy/20 rounded-full"></span>
                    <span className="flex items-center gap-1.5"><Clock size={16} /> {job.type}</span>
                  </div>
                </div>
                <div>
                  <Button variant="outline" className="w-full md:w-auto px-6 border-navy/20 group-hover:bg-primary group-hover:text-white group-hover:border-primary transition-colors">
                    Apply Now
                  </Button>
                </div>
              </div>
            ))}
          </div>
          
          <div className="mt-12 p-8 bg-primary/5 rounded-2xl border border-primary/10 text-center">
            <h3 className="text-xl font-bold text-navy mb-2">Don't see your role?</h3>
            <p className="text-navy/70 mb-6">We're always looking for exceptional talent. Send us your resume anyway.</p>
            <Button variant="outline" className="px-6 border-primary text-primary hover:bg-primary hover:text-white">
              Send Open Application
            </Button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Jobs;
